<template>
  <div data-component-group="sponsor-dialog" data-component="add-new">
    <dialog-add
      :title="$t('logo_sponsorship')"
      icon="bolt"
      is-fullscreen
      :is-on="true"
      :on-close="onCancel"
    >
      <template v-slot:content>
        <forms-sponsorships-edit
          ref="editSponsorshipForm"
          class="elevation-1"
          @saved="$emit('saved')"
        />
      </template>
    </dialog-add>
  </div>
</template>

<script>
export default {
  emits: ['saved'],
  methods: {
    onCancel() {
      this.$refs.editSponsorshipForm.cancel();
    },
  },
};
</script>
